import { getProductsDetailsResponse, ProductVariantAttribute } from '../orders';
import { Product, Promotion } from '../products';
import { CustomerSegment } from '../customers';
import { WhatsappTemplateData } from '@zonofi/common';

export enum PublishStatus {
  PUBLISHED = 'Published',
  NOT_PUBLISHED = 'Not Published',
  EXPIRED = 'Expired',
}
export enum CampaignActionType {
  'TEMPLATE_VIEW' = 'Template View',
  'CREATE_CAMPAIGN' = 'Create Campaign',
  'CAMPAIGN_EDIT' = 'Campaign Edit',
  'CUSTOMER_EDIT' = 'Customer Edit',
  'PRODUCT_EDIT' = 'Product Edit',
  'AUDIENCE_EDIT' = 'Audience Edit',
  'PREVIEW' = 'Preview',
  'UPLOAD_CUSTOMER' = 'Upload Customer',
  'SEARCH_AND_ADD' = 'Search And Add',
}

export enum SelectedTemplate {
  'ALL' = 'All',
  'ONE_FRAME' = 'One Frame',
  'CAROUSEL' = 'Carousel',
  'CUSTOM' = 'Custom',
}

export enum CampaignMessageStatus {
  IMPRESSIONS = 'IMPRESSIONS',
  SUCCESS = 'SUCCESS',
  ORDERED = 'ordered',
  ENGAGED = 'engaged',
  SETUP_ERROR = 'SETUP_ERROR',
  RATE_LIMIT_HIT = 'RATE_LIMIT_HIT',
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  NUMBER_ERROR = 'NUMBER_ERROR',
}

export enum CampaignMessageEnum {
  MESSAGE_SENT = 'MESSAGE_SENT',
  MESSAGE_DELIVERED = 'MESSAGE_DELIVERED',
  MESSAGE_SEEN = 'MESSAGE_SEEN',
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  NUMBER_ERROR = 'NUMBER_ERROR',
  SETUP_ERROR = 'SETUP_ERROR',
  RATE_LIMIT_HIT = 'RATE_LIMIT_HIT',
  SPAM_RATE_LIMIT_HIT = 'SPAM_RATE_LIMIT_HIT',
  TOO_MANY_REQUEST = 'TOO_MANY_REQUEST',
  INVALID_REQUEST = 'INVALID_REQUEST',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  Total_Impressions = 'Total Impressions',
  Total_Engaged = 'Total Engaged',
  Total_Sent = 'Total Sent',
  Total_Ordered = 'Total Ordered',
  INVALID_RECIPIENT = 'INVALID_RECIPIENT',
  INCAPABLE_RECIPIENT = 'INCAPABLE_RECIPIENT',
  RECIPIENT_BLOCKED = 'RECIPIENT_BLOCKED',
  UNSUPPORTED_MESSAGE = 'UNSUPPORTED_MESSAGE',
  MEDIA_DOWNLOAD_ERROR = 'MEDIA_DOWNLOAD_ERROR',
  MEDIA_UPLOAD_ERROR = 'MEDIA_UPLOAD_ERROR',
  REENGAGEMENT_ERROR = 'REENGAGEMENT_ERROR',
  INVALID_PARAM = 'INVALID_PARAM',
  MISSING_PARAM = 'MISSING_PARAM',
  INVALID_PARAM_VALUE = 'INVALID_PARAM_VALUE',
  TEMPLATE_ERROR = 'TEMPLATE_ERROR',
  TEMPLATE_PARAM_ERROR = 'TEMPLATE_PARAM_ERROR',
  TEMPLATE_NOT_FOUND = 'TEMPLATE_NOT_FOUND',
  TEMPLATE_TEXT_TOO_LONG = 'TEMPLATE_TEXT_TOO_LONG',
  INVALID_TEMPLATE_NAMESPACE = 'INVALID_TEMPLATE_NAMESPACE',
  MESSAGE_PENDING_TOO_LONG = 'MESSAGE_PENDING_TOO_LONG',
  MESSAGE_EXPIRED = 'MESSAGE_EXPIRED',
  MESSAGE_TOO_LONG = 'MESSAGE_TOO_LONG',
  WEBHOOK_ERROR = 'WEBHOOK_ERROR',
  SECTION_COUNT_ERROR = 'SECTION_COUNT_ERROR',
  ROWS_COUNT_ERROR = 'ROWS_COUNT_ERROR',
  PRODUCT_COUNT_ERROR = 'PRODUCT_COUNT_ERROR',
  CATALOGUE_NOT_FOUND = 'CATALOGUE_NOT_FOUND',
  CATALOGUE_NOT_LINKED = 'CATALOGUE_NOT_LINKED',
  MISSING_PRODUCT = 'MISSING_PRODUCT',
  PRODUCT_NOT_FOUND = 'PRODUCT_NOT_FOUND',
  PRODUCT_COMPLIANCE_ERROR = 'PRODUCT_COMPLIANCE_ERROR',
  INVALID_HEADER = 'INVALID_HEADER',
  MISSING_COMPLIANCE = 'MISSING_COMPLIANCE',
  CHAR_POLICY_VIOLATION = 'CHAR_POLICY_VIOLATION',
  RESTRICTED_BY_META = 'RESTRICTED_BY_META',
  ENGAGED = 'ENGAGED',
  ORDERED = 'ORDERED',
  engaged = 'engaged',
  ordered = 'ordered',
  ERROR = 'ERROR',
  SENT = 'SENT',
  IMPRESSIONS = 'IMPRESSIONS',
  error = 'error',
  ERROR_2 = 'error',
  isCompleted = 'isCompleted',
}

export enum AdSource {
  CTWA = 'CTWA',
  META = 'METALEADGEN',
  INDIAMART = 'INDIAMART',
}

export interface campaignBotsType {
  id: string;
  name: string;
}

export enum RepeatTypeEnum {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  // YEAR = 'YEAR',
}

export const TriggerOnWeekDay = [
  {
    label: 'First',
    value: 'First',
  },
  {
    label: 'Second',
    value: 'Second',
  },
  {
    label: 'Third',
    value: 'Third',
  },
  {
    label: 'Fourth',
    value: 'Fourth',
  },
  {
    label: 'Last',
    value: 'Last',
  },
];

export const FrequencyWeekDay = [
  {
    label: 'S',
    value: '0',
  },
  {
    label: 'M',
    value: '1',
  },
  {
    label: 'T',
    value: '2',
  },
  {
    label: 'W',
    value: '3',
  },
  {
    label: 'T',
    value: '4',
  },
  {
    label: 'F',
    value: '5',
  },
  {
    label: 'S',
    value: '6',
  },
];

export const FrequencyWeekDays = [
  {
    label: 'Sunday',
    value: 'Sunday',
  },
  {
    label: 'Monday',
    value: 'Monday',
  },
  {
    label: 'Tuesday',
    value: 'Tuesday',
  },
  {
    label: 'Wednesday',
    value: 'Wednesday',
  },
  {
    label: 'Thursday',
    value: 'Thursday',
  },
  {
    label: 'Friday',
    value: 'Friday',
  },
  {
    label: 'Saturday',
    value: 'Saturday',
  },
];

export const TriggerFinders = {
  First: '1',
  Second: '2',
  Third: '3',
  Fourth: '4',
  Last: '5',
  Sunday: '0',
  Monday: '1',
  Tuesday: '2',
  Wednesday: '3',
  Thursday: '4',
  Friday: '5',
  Saturday: '6',
  '0': 'Sunday',
  '1': 'Monday',
  '2': 'Tuesday',
  '3': 'Wednesday',
  '4': 'Thursday',
  '5': 'Friday',
  '6': 'Saturday',
};

export interface CreateCampaignRequest {
  workspaceId: string;
  sellerWorkspaceId: string;
  body: any;
}

interface MessageBody {
  name: string;
  description: string;
  productVariants: string[];
}
interface Message {
  message: string;
  method: string;
  body: MessageBody;
}

export interface CampaignItem {
  id: string;
  createdDate: string;
  updatedDate: string;
  startDate: string;
  adId?: string;
  postId?: string;
  endDate: string;
  code: string;
  botId: string;
  eventTriggers: string;
  botDetails: {
    id: string;
    name: string;
    isEnabled: boolean;
    startConditionDescription: string;
  };
  name: string;
  isCTWAEnabled?: boolean;
  isRecurring?: boolean;
  scheduleScope?: 'CAMPAIGN' | 'CUSTOMER';
  customers?: customer[];
  adSource?: AdSource;
  description: string;
  imagePreview: string;
  channelId?: number;
  template: WhatsappTemplateData;
  productVariants?: getProductsDetailsResponse[];
  productVariantAttribute?: ProductVariantAttribute;
  assets: campaginAsset[];
  metric: metric;
  status: PublishStatus;
  customersCount: number;
  productVariantsCount: number;
  publishedDate: string;
  type: string;
  audienceType?: string;
}

export enum CampaignMessage {
  CUSTOMER_CONTACT_NAME = 'customer_contact_name',
  CUSTOMER_FIRM_NAME = 'customer_firm_name',
  SELLER_FIRM_NAME = 'seller_firm_name',
  SELLER_WABA_NUMBER = 'seller_waba_number',
  SELLER_WABA_NUMBER_WA_ME_LINK = 'seller_waba_number_wa_me_link',
  CAMPAIGN_NAME = 'campaign_name',
  PRODUCT = 'product',
  CUSTOM_MESSAGE = 'custom_message',
}

interface customer {
  createdAt: string;
  updatedAt: string;
  campaignId: string;
  customerId: string;
  isSent: boolean;
  id: number;
  customer: any;
}

export interface CreateCampaignResponse {
  statusCode: number;
  message: Message | string;
  id: string;
  data: CampaignItem;
  isScheduled?: boolean;
}

export interface CampaignListRequest {
  workspaceId: string;
  sellerWorkspaceId: string;
  body?: {
    status?: string[];
    imagePreview?: string[];
    adSource?: string[];
    audienceType?: string[];
    botSearchKey?: string;
  };
  params?: {
    pageNo?: number;
    pageSize?: number;
    searchKeyword?: string;
    startDate?: string;
    endDate?: string;
    sort?: string;
    order?: string;
    customerId?: any;
  };
}

export interface campaginAsset {
  id: number;
  createdAt: string;
  updatedAt: string;
  name: string;
  type: string;
  mimeType: string;
  width: number;
  height: number;
  fileSize: number;
  source: string;
  preview: string;
  focalPoint: {
    x: number;
    y: number;
  };
}

export interface CampaignListResponse {
  statusCode: number;
  message: string;
  data: CampaignItem[];
  totalCount: number;
  startRecord: number;
  endRecord: number;
}

export interface metric {
  target: number;
  engaged: number;
  id: string;
  impressions: number;
  delivered: number;
  ordered: number;
  sent: number;
  roi: number;
}

export interface CampaignResponse {
  statusCode: number;
  message: string;
  data: CampaignItem;
}

export interface CampaignRequest {
  campaignId: string;
  workspaceId: string;
  customerId?: string;
  sellerWorkspaceId: string;
}
interface UpdateCampaignBodyRequest {
  name?: string;
  type?: string;
  description?: string;
  productVariants?: number[];
}

export interface UpdateCampaignRequest {
  campaignId: string;
  workspaceId: string;
  sellerWorkspaceId: string;
  body: UpdateCampaignBodyRequest;
}

export interface CampaignType {
  id: number;
  title: string;
  description: string;
  selected: boolean;
  first?: boolean;
  last?: boolean;
  value: string;
}

interface FunnelCount {
  number: number;
  percentage: number;
}

export interface CampaignDetails {
  campaignName: string;
  status: PublishStatus;
  customerCount: number;
  productCount: number;
  createdDate: string;
  isRecurring: boolean;
  publishedDate: string;
  updatedDate: string;
  description: string;
  type: string;
  productView: string;
  template: WhatsappTemplateData;
  botDetails: {
    id: string;
    name: string;
    isEnabled: boolean;
    startConditionDescription: string;
  };
  eventTriggers: string;
  teamMembers: {
    memberId: string;
    memberName: any;
  }[];
  adSource?: AdSource;
  source: string;
  botId: string;
  audienceType: 'static' | 'dynamic' | 'dynamic_algo' | 'dynamic_rule';
  schedules: CampaignScheduleDetails[];
  scheduleScope: 'CAMPAIGN' | 'CUSTOMER';
  imagePreview: string;
  isCTWAEnabled: boolean;
  productVariants: Product[];
  campaignFunnel: CampaignFunnelDetails;
  dynamicSegments: any[];
  customerGroups: {
    customerGroupId: string;
    customerGroupType: string;
    customerGroupName: string;
  }[];
  returnOnInvestments: ReturnOnInvestmentsDetails;
  adId: string;
  postId: string;
  startDate: string;
  weekDays: string;
  triggerOnDay: string;
  endDate: string;
  repeatFrequency: string;
  repeatType: RepeatTypeEnum;
}

export interface CampaignScheduleDetails {
  startDate: string;
  endDate: string;
  repeatFrequency: number;
  repeatType: string;
  weekDays: string;
  triggerOnDay: string;
  isActive: number;
  scheduleId: string;
  customerId: string;
  triggerOnWeekDay: string;
}

export interface CampaignFunnelDetails {
  deliveredCount: FunnelCount;
  sentCount: FunnelCount;
  engagedCount: FunnelCount;
  orderedCount: FunnelCount;
  seenCount: FunnelCount;
  MESSAGE_DELIVERED: FunnelCount;
  MESSAGE_SENT: FunnelCount;
  MESSAGE_SEEN: FunnelCount;
  MESSAGE_ENGAGED: FunnelCount;
  engaged: FunnelCount;
  error: FunnelCount;
}

export interface ReturnOnInvestmentsDetails {
  campaignBudget: number;
  totalReturn: number;
}

interface MetricDataItem {
  dateTime: string;
  description: string;
  type?: string;
}

export type MetricData = Record<CampaignMessageEnum, MetricDataItem>;

export interface CampaignDetailsResponse {
  statusCode: number;
  message: string;
  data: CampaignDetails;
}

export interface CampaignDetailsRequest {
  campaignId: string;
  workspaceId: string;
  sellerWorkspaceId: string;
  includeProducts?: boolean;
}

export interface CampaignCustomer {
  firmName: string;
  phoneNumber: string;
  inviteId: string;
  lastName: string;
  firstName: string;
  customerCode: string;
  totalReturn: number;
  metric?: MetricData;
  customerChannels?: CustomerSegment[];
}
export interface CampaignCustomersData {
  customers: CampaignCustomer[];
  endRecord: number;
  startRecord: number;
  totalItems: number;
  totalPages: number;
  filter: {
    type: string;
    options: {
      name: CampaignMessageEnum;
      count: number;
      channelId?: string;
      channelName?: string;
    }[];
  }[];
}

export interface CampaignCustomersResponse {
  statusCode: number;
  message: string;
  data: CampaignCustomersData;
}

export interface CampaignCustomersRequest {
  id: string;
  workspaceId: string;
  pageNo: number;
  pageSize: number;
  searchKey?: string;
  stats?: string;
  sellerWorkspaceId: string;
  isActive?: number;
}

export interface CampaignProduct {
  total: number;
  startRecord: number;
  endRecord: number;
  products: Product[];
  categoryCodes: {
    categoryName: string;
    categoryCode: string;
    categoryId: string;
  }[];
  divisionSummary: {
    divisionCode: string;
    divisionId: string;
    name: string;
    headDivisionId: string;
    headDivision: {
      id: string;
      code: string;
      name: string;
    };
    isDefault: boolean;
  }[];
  cfaSummary: {
    cfaCode: string;
    cfaId: string;
    supplierName: string;
    isDefault: boolean;
  }[];
  status: string;
  statusCode: number;
}

export interface CampaignProductsResponse {
  statusCode: number;
  message: string;
  data: CampaignProduct;
}
export interface CampaignProductsRequest {
  campaignId: string;
  sellerWorkspaceId: string;
  workspaceId: string;
  searchKey?: string;
  divisionIds?: string[];
  categoryCodes?: string[];
  pageNo?: number;
  pageSize?: number;
  customerId?: string;
}

export interface RemoveProductFromCampaigntResponse {
  message: string;
}
export interface RemoveProductFromCampaignRequest {
  productVariantIds: number[];
  campaignId: string;
  sellerWorkspaceId: string;
}

export interface RemoveAllProductFromCampaignRequest {
  campaignId: string;
  sellerWorkspaceId: string;
  body: {
    productVariantIds: number[];
    productFilters?: Record<string, any>;
    isSelectAllProducts?: boolean;
  };
}

export interface RemoveCustomerFromCampaigntResponse {
  message: string;
}
export interface RemoveCustomerProductFromCampaignRequest {
  customerIds: string[];
  campaignId: string;
  sellerWorkspaceId: string;
}

export interface CampaignDetailsV2Response {
  statusCode: number;
  message: string;
  data: CampaignDetailsV2Data;
}

export interface CampaignDetailsV2Data {
  campaignName: string;
  description?: string;
  source?: string;
  type: string;
  createdDate: string;
  id: string;
  productVariants: CampaignDetailsV2ProductVariant[];
  startRecord: number;
  endRecord: number;
  total: number;
}

export interface CampaignDetailsV2ProductVariant {
  parentSku: string;
  productAsset: CampaignDetailsV2ProductAsset;
  source: string;
  preview: string;
  enabled: boolean;
  id: number;
  productVariants: CampaignDetailsV2ProductVariant2[];
  channelId: number;
  workspaceId: string;
}

export interface CampaignDetailsV2ProductAsset {}

export interface CampaignDetailsV2ProductVariant2 {
  facets: any[];
  assets: {
    filename: string;
    redirectUrl: string;
    sequenceNo: number;
    subType: string;
  }[];
  taxCategory: CampaignDetailsV2TaxCategory;
  enabled: boolean;
  price: number;
  MRP: number;
  PTR: number;
  isSpecial: any;
  sku: string;
  sortOrder: number;
  id: number;
  taxCategoryId: number;
  productId: number;
  name: string;
  shortName: string;
  shortDescription: string;
  categories: CampaignDetailsV2Category[];
  productVariantId: number;
  ean: string;
  erpId: string;
  erpPriceUOM: string;
  erpUOM: string;
  ZINS: boolean;
  hsnCode: string;
  upcCode: string;
  baseUom: string;
  quantity: number;
  warrentyInformation: string;
  condition: string;
  packSize: number;
  manufacturingDate: any;
  expiryDate: any;
  bestBeforeOrAfter: any;
  popularity: number;
  bestAfter: any;
  minOrderQty: number;
  maxOrderQty: number;
  minRemShelfLife: number;
  qtyMultiplier: number;
  grossWeight: any;
  netWeight: any;
  volume: any;
  division: CampaignDetailsV2Division[];
  cfas: CampaignDetailsV2Cfa[];
  collections: any[];
  promotions: Promotion[];
  stock: number;
  sales: number;
  margin: string;
  isActiveForOrderCfaIds: string[];
  salesOrg: any;
}

export interface CampaignDetailsV2TaxCategory {
  id: number;
  name: string;
}

export interface CampaignDetailsV2Category {
  categoryId: number;
  categoryName: string;
  categoryCode: string;
}

export interface CampaignDetailsV2Division {
  divisionCode: string;
  divisionId: string;
  name: string;
  headDivisionId: string;
  headDivision: CampaignDetailsV2HeadDivision;
  isDefault: boolean;
}

export interface CampaignDetailsV2HeadDivision {
  id: string;
  code: string;
  name: string;
}

export interface CampaignDetailsV2Cfa {
  cfaCode: string;
  cfaId: string;
  supplierName: string;
  isDefault: boolean;
  minOrderQty: number;
}

export interface CampaignDetailsV2Request {
  workspaceId: string;
  params: {
    campaignId: string;
    customerId?: string;
    sellerWorkspaceId: string;
    includeProducts: boolean;
  };
}

export interface SendCampaignInterface {
  id: string;
  name: string;
  description: string;
  type: string;
  sellerName: string;
  assetUrl: string;
  products: {
    translations: { name: string }[];
    productVariantPrices: { price: number }[];
    productVariantAttribute: { minOrderQty: number };
  };
}

export interface CampaignFiltersResponse {
  status: PublishStatus[];
  imagePreview: string[];
  adSource: AdSource[];
  bots: campaignBotsType[];
  audienceType: string[];
}
export interface CampaignFiltersRequest {
  workspaceId: string;
  sellerWorkspaceId: string;
  pageNo: number;
  pageSize: number;
}

export interface PublishCampaignResponse {}
export interface PublishCampaignRequest {
  workspaceId: string;
  sellerWorkspaceId: string;
  body: {
    campaignId: string;
    customerGroupIds?: string[];
    segmentIds?: string[];
    sendAll?: boolean;
    customerIds?: string[];
  };
}

export interface CampaignTemplate {
  campaignName?: string;
  campaignDescription?: string;
  productView?: string;
  productList?: {
    imgUrl: string;
    productDescription: string;
    carouselButtons: string[];
    messages: { id: string; value: string }[];
  }[];
  messages?: {
    id: string;
    value: string;
    msgId: string;
    isActive: boolean;
  }[];
  footerText?: string;
  buttons?: string[];
  headerDetails?: {
    campaignHeaderFormat: string;
    headerText: string;
    dataUrl: any;
  };
  isfooterIncludes?: boolean;
  template?: WhatsappTemplateData;
  templateDescription?: string;
  campaignTitle?: string;
  laguage?: string;
}

export interface CampaignCustomerUploadResponse {
  totalRecords: number;
  previewData: any[];
  excelColumns: string[];
  dbFields: {
    field: string;
    label: string;
  }[];
  success: boolean;
  campaign: {
    id: string;
    name: string;
    isNew: boolean;
  };
  stats: {
    totalRecords: number;
    processedRecords: number;
    matchedCustomers: number;
    addedToCampaign: number;
  };
}
export interface CampaignCustomerUploadRequest {
  workspaceId: string;
  sellerWorkspaceId: string;
  body: any;
}

export interface CampaignCustomerReportDownloadRequest {
  sellerWorkspaceId: string;
  pageNo?: number;
  pageSize?: number;
  campaignId: string;
  attemptId: string;
  filters: {
    campaignStatus?: string[];
    segments?: string[];
    routes?: string[];
    dynamicSegments?: string[];
  };
}

export interface CampaignRevenueResponse {
  data: {
    dateRange: string;
    orderValue: number;
  }[];
}
export interface CampaignRevenueRequest {
  startDate: string;
  endDate: string;
  sellerWorkspaceId: string;
}

export interface RevenueBreakdownResponse {
  data: {
    agent: {
      orderValue: number;
      orderPercent: number;
    };
    customer: {
      orderValue: number;
      orderPercent: number;
    };
    sales: {
      orderValue: number;
      orderPercent: number;
    };
    camapign: {
      orderValue: number;
      orderPercent: number;
    };
    totalOrderValue: number;
    updatedAt: string;
  };
}
export interface RevenueBreakdownRequest {
  startDate: string;
  endDate: string;
  sellerWorkspaceId: string;
}

interface CampaignReport {
  dateRange: string;
  orderSources: {
    agent: {
      value: number;
      percent: number;
    };
    customer: {
      value: number;
      percent: number;
    };
    sales: {
      value: number;
      percent: number;
    };
    campaign: {
      value: number;
      percent: number;
    };
  };
  totalOrderValue: number;
  updatedAt?: string;
}
export interface CampaignReportResponse {
  data: CampaignReport[];
}
export interface CampaignReportRequest {
  startDate: string;
  endDate: string;
  sellerWorkspaceId: string;
  groupBy: 'dateRange' | 'overall';
}

export interface CampaignFrequency {
  startDate: any;
  startTime: any;
  repeatFrequency: string;
  repeatType: RepeatTypeEnum;
  endDate: any;
  weekDays: string;
  isTriggerOnDay: boolean;
  triggerOnDay: string;
  triggerOnWeekDay: string;
  inviteId?: string;
  index?: number;
}

export interface CampaignDataProps {
  campaignName: string;
  campaignDescription: string;
  campaignType: string;
  productView: any;
  productsIds?: string[];
  assignedProductIds?: string[];
  assignedCustomerIds?: string[];
  assignedParsedCustomerIds?: string[];
  assignedParsedProductIds?: number[];
  selectedCampaignId?: string;
  customersIds?: string[];
  draftCustomerIds?: string[];
  eventTriggers?: string;
  draftProductIds?: number[];
  draftTeamMemberIds?: string[];
  teamMembers?: { name: string; id: string }[];
  uri?: string;
  imageUri?: string;
  scheduleId?: string;
  fileError?: boolean;
  selectedTemplate?: CampaignTemplate;
  uploadFile?: File | undefined;
  publishNow: boolean;
  status?: PublishStatus;
  messages?: { id: string; value: string; msgId: string; isActive: boolean }[];
  scheduleCustomerLevel?: boolean;
  template?: WhatsappTemplateData;
  whatsAddEnabled?: boolean;
  AddId?: string;
  postId?: string;
  templateDescription?: string;
  scheduleEnable?: boolean;
  startDate?: any;
  endDate?: any;
  startTime?: any;
  endTime?: any;
  selectedTab?: number;
  totalCustomers?: number;
  totalProducts?: number;
  buttons?: string[];
  productsData?: Product[];
  adSource?: AdSource;
  botEnable?: boolean;
  openCampaignReccurence?: {
    open: boolean;
    id: string;
  };
  botLibraryId?: string;
  isBotEdit?: boolean;
  headerDetails?: {
    campaignHeaderFormat: string;
    headerText: string;
    dataUrl: any;
  };
  selectedBot?: {
    botName: string;
    status: boolean;
    triggers: string;
    botId: string;
  };
  audienceType?:
    | 'static'
    | 'dynamic_algo'
    | 'dynamic_rule'
    | 'dynamic'
    | 'ctwa'
    | 'events';
  footerText?: string;
  isfooterIncludes?: boolean;
  teamMemberEnable?: boolean;
  productList?: {
    imgUrl: string;
    messages: { id: string; value: string }[];
    productDescription: string;
    carouselButtons: string[];
  }[];
  dateError: string;
  campaignFrequencyEnable?: boolean;
  isSubscribed?: boolean;
  dynamicSegmentIds?: string[];
  customerSegmentIds?: string[];
  routeIds?: string[];
  lifecycleIds?: string[];
  customerLevelCampaignFrequency?: CampaignFrequency[];
  campaignFrequency?: CampaignFrequency;
}

export interface CreateTrialCampaignRequest {
  params: {
    sellerWorkspaceId: string;
    doPublish?: boolean;
  };
}

export interface CreateTrialCampaignResponse {
  id: string;
  message: string;
  statusCode: number;
}

export interface CampaignAudienceResponse {
  statusCode: number;
  message: string;
  data: {
    data: CampaignAudienceData[];
    total: number;
    pageNo: string;
    pageSize: string;
    totalPages: number;
    startRecord: number;
    endRecord: number;
  };
}

export interface CampaignAudienceRequest {
  workspaceId: string;
  sellerWorkspaceId: string;
  id: string;
  pageNo: number;
  pageSize: number;
  searchKey?: string;
}

export interface CampaignAudienceData {
  id: number;
  createdAt: string;
  dynamicSegmentId?: string;
  customerGroupId?: string;
  customerGroupType?: 'SEGMENT' | 'ROUTE' | 'CUSTOMER_LIFE_CYCLE';
  customerId?: string;
  name: string;
}

export interface CampaignAttemptCustomer {
  lastMessage?: string;
  results?: number;
  conversationId?: string;
  stats?: MetricData;
  firstName?: string;
  firmName?: string;
  phoneNumber?: string;
  mobileNo?: string;
  customerCode: string;
  lastName?: string;
  id: string;
  schedule?: string;
  sNo?: string;
  sent?: JSX.Element;
  customerName?: JSX.Element;
  impressions?: JSX.Element;
  engaged?: JSX.Element;
  ordered?: JSX.Element;
  isCompleted?: JSX.Element;
  isFooter?: boolean;
  addedDate?: string;
  delivered?: JSX.Element;
}

export interface CampaignAttemptsResponse {
  statusCode: number;
  message: string;
  data: {
    attempts: {
      id: string;
      customers: CampaignAttemptCustomer[];
      metrics: {
        'Total Impressions': number;
        'Total Sent': number;
        'Total Engaged': number;
        'Total Ordered': number;
        'Total Delivered': number;
      };
      endRecord: number;
      startRecord: number;
      totalItems: number;
      totalPages: number;
    };
    attemptsSummary: {
      id: string;
      attemptDate: string;
    }[];
    filters: {
      dynamicSegments: {
        id: string;
        name: string;
      }[];
      routes: {
        id: string;
        name: string;
      }[];
      segments: {
        id: string;
        name: string;
      }[];
      campaignStatus: {
        key: string;
        formattedKey: string;
      }[];
    };
  };
}

export interface CampaignAttemptsRequest {
  workspaceId: string;
  sellerWorkspaceId: string;
  campaignId: string;
  attemptId?: string;
  pageNo: number;
  pageSize: number;
  campaignStatusList?: string[];
  dynamicSegmentsList?: string[];
  routesList?: string[];
  segmentsList?: string[];
}

export interface DeleteCampaignAudienceResponse {}
export interface DeleteCampaignAudienceRequest {
  campaignId: string;
  workspaceId: string;
  sellerWorkspaceId?: string;
  body: {
    audienceType: 'static' | 'dynamic' | 'dynamic_rule' | 'dynamic_algo';
    customerGroupIds?: string[];
    dynamicSegmentIds?: string[];
    customerIds?: string[];
    isSelectAllCustomers?: boolean;
  };
}

export interface DeleteCampaignTeamMemberRequest {
  campaignId: string;
  workspaceId: string;
  sellerWorkspaceId: string;
  body: {
    teamMemberIds: string[];
  };
}

export interface DeleteCamapaignTeamMemberResponse {}

export interface DeleteBotFromCampaignResponse {}

export interface DeleteBotFromCampaignRequest {
  sellerWorkspaceId: string;
  body: {
    botIds: string[];
  };
}

export enum CampaignScheduleTimingEnum {
  SCHEDULE = 'schedule',
  RECURRENCE = 'recurrence',
}

export enum ActiveDateFieldEnum {
  START = 'start',
  END = 'end',
}

export enum RecurrenceTypeEnum {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}

export enum CampaignAudienceType {
  CUSTOMER = 'Customers',
  DYNAMIC_SEGMENTS = 'Dynamic Segments',
  SEGMENTS = 'Segments',
  ROUTES = 'Routes',
}
export interface CampaignTeamMembersResponse {
  teamMemberDetails: {
    name: string;
    mobile: string;
    id: string;
    type: string;
    role: string;
  }[];
  totalRecords: number;
  startRecord: number;
  endRecord: number;
}
export interface CampaignTeamMembersRequest {
  params: {
    sellerWorkspaceId: string;
  };
  body: {
    campaignId: string;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
  };
}

export interface CustomerStatsRequest {
  params: {
    sellerWorkspaceId: string;
    campaignId: string;
    pageNo: number;
    pageSize: number;
  };
  attemptId: string;
  blockId: string;
}

export interface CustomerStatsResponse {
  statusCode: number;
  message: string;
  data: {
    attemptId: string;
    blockId: string;
    customers: {
      sNo: number;
      customerId: string;
      customerName: string;
      contactName: string;
      phone: string;
      sent: number;
      delivered: number;
      seen: number;
      engaged: number;
    }[];
    pagination: {
      page: number;
      pageSize: number;
      total: number;
      totalPages: number;
    };
  };
}
